module.exports = __webpack_public_path__ + "static/media/4.9cdce7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Schokwave/Images/4.png
// module id = 695
// module chunks = 0